import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import { sxButton, sxModal } from './sxProps';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { Button } from '@mui/material';
import './styles.css'
import { RegisterModalProps } from '../../../interfaces/props/SaudeOnline/BiometriaFacial/RegisterModalProps';
import ScanIcon from './ScanIcon';

function RegisterModal(props: RegisterModalProps) {

    const handleRegistration = () => {
        props.handleRegistration();
    }

    return (

        <div>
            <Modal
                open={props.open}
                onClose={handleRegistration}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={sxModal}>
                    <div className="camera-permition-feedback-modal-header">
                        <button className='camera-permition-modal-header-close' onClick={props.handleCloseModal}>
                            <FontAwesomeIcon icon={faTimes} />
                        </button>
                    </div>
                    <div className="modal-icon-holder">
                        <ScanIcon />
                    </div>
                    <h1 className="camera-permition-feedback-modal-title">
                        Você não possui biometria facial cadastrada. Deseja cadastrar agora?
                    </h1>
                    <p className="camera-permition-feedback-modal-message">
                        Com a biometria facial, seu acesso ao atendimento fica mais rápido, fácil e seguro.
                    </p>
                    <div className="camera-permition-button-holder">
                        <Button
                            variant="contained"
                            onClick={handleRegistration}
                            sx={sxButton}
                            disabled={false}
                            fullWidth>
                            Cadastrar biometria facial
                        </Button>
                    </div>
                </Box>
            </Modal>
        </div>
    );
}

export default RegisterModal;